/**
 * Translates field names from backend that contain hardcoded English prefixes
 * @param fieldName - The field name from the backend (e.g., "Attribute: Color", "Weight: 1")
 * @param getTranslation - Function to get translated text
 * @returns The translated field name
 */
export function translateFieldName(
  fieldName: string,
  getTranslation: (key: string) => string
): string {
  // Handle "Attribute: " prefix
  if (fieldName.startsWith('Attribute: ')) {
    const attributeName = fieldName.substring(11); // Remove "Attribute: "
    const translatedAttribute = getTranslation('completenessDrilldown.labels.attribute');
    return `${translatedAttribute}: ${attributeName}`;
  }

  // Handle "Weight: " prefix
  if (fieldName.startsWith('Weight: ')) {
    const weightValue = fieldName.substring(8); // Remove "Weight: "
    const translatedWeight = getTranslation('completenessDrilldown.labels.weight');
    return `${translatedWeight}: ${weightValue}`;
  }

  // Handle other common field name patterns
  const fieldTranslationMap: Record<string, string> = {
    Name: 'tabs.dataCompleteness.fieldNames.name',
    SKU: 'tabs.dataCompleteness.fieldNames.sku',
    Description: 'tabs.dataCompleteness.fieldNames.description',
    Category: 'tabs.dataCompleteness.fieldNames.category',
    Brand: 'tabs.dataCompleteness.fieldNames.brand',
    'GTIN/Barcode': 'tabs.dataCompleteness.fieldNames.gtinBarcode',
    Tags: 'tabs.dataCompleteness.fieldNames.tags',
    Images: 'tabs.dataCompleteness.fieldNames.images',
  };

  const translationKey = fieldTranslationMap[fieldName];
  if (translationKey) {
    return getTranslation(translationKey) || fieldName;
  }

  // Return original field name if no translation found
  return fieldName;
}
